import { render, staticRenderFns } from "./detailsWarehouseOutTable.vue?vue&type=template&id=64bd064e&scoped=true"
import script from "./detailsWarehouseOutTable.vue?vue&type=script&lang=js"
export * from "./detailsWarehouseOutTable.vue?vue&type=script&lang=js"
import style0 from "./detailsWarehouseOutTable.vue?vue&type=style&index=0&id=64bd064e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bd064e",
  null
  
)

export default component.exports